<template>
  <div>
    <!-- MOBILE TOGGLE BUTTON -->
    <!-- prettier-ignore -->
    <button class="mobile-toggle" @click="isOpen = !isOpen">
      ☰
    </button>

    <!-- SIDEBAR -->
    <!-- prettier-ignore -->
    <aside class="sidebar" :class="{ open: isOpen }">
      <div class="logo-wrapper">
        <img src="@/assets/logo.png" alt="Klam Freestyle Logo" class="logo" width="120px;" style="margin-left: auto; margin-right: auto; display: block;" />
      </div>
      <nav>
        <ul>
          <li><router-link to="/">Home</router-link></li>
          <li class="section-title"><router-link to="/coach">Coach Kris</router-link></li>
          <li class="section-title">Theory</li>
          <ul class="subnav">
            <li><router-link to="/theory/gear">Gear</router-link></li>
            <li><router-link to="/theory/workout">Workout</router-link></li>
            <li><router-link to="/theory/tips">Tips & Tricks</router-link></li>
          </ul>
        </ul>
      </nav>
    </aside>

    <!-- BACKDROP (mobile only) -->
    <div v-if="isOpen" class="backdrop" @click="isOpen = false"></div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const isOpen = ref(false);
watch(route, () => {
  isOpen.value = false;
});
</script>

<style scoped>
.sidebar {
  width: 240px;
  background: #111;
  color: white;
  height: 100vh;
  padding: 1.5rem;
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.3s ease;
  z-index: 200;
}

/* MOBILE: sidebar hidden by default */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
  }
  .sidebar.open {
    transform: translateX(0);
  }
}

/* LINKS */
.sidebar a {
  color: white;
  text-decoration: none;
  display: block;
  padding: 0.4rem 0;
}

.section-title {
  margin-top: 1.5rem;
  font-weight: bold;
  opacity: 0.8;
}

.subnav {
  margin-left: 1rem;
  margin-top: 0.5rem;
}

/* MOBILE TOGGLE BUTTON */
.mobile-toggle {
  display: none;
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 300;
  background: #111;
  color: white;
  border: none;
  padding: 0.6rem 0.8rem;
  font-size: 1.4rem;
  border-radius: 6px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .mobile-toggle {
    display: block;
  }
}

/* BACKDROP */
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 150;
}
</style>
